module.exports = "/_next/static/images/quotes-36b9bb9b35253a7f9a2b89ef74e0f280.png";